import { __decorate } from 'tslib';
import { Input, HostBinding, Directive, NgModule } from '@angular/core';

/**
 * Abstraction over `tabindex`
 */
import * as ɵngcc0 from '@angular/core';
let TuiFocusableDirective = class TuiFocusableDirective {
    constructor() {
        /**
         * Element can be focused with keyboard
         */
        this.focusable = true;
    }
    get tabIndex() {
        return this.focusable ? 0 : -1;
    }
};
TuiFocusableDirective.ɵfac = function TuiFocusableDirective_Factory(t) { return new (t || TuiFocusableDirective)(); };
TuiFocusableDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiFocusableDirective, selectors: [["", "tuiFocusable", ""]], hostVars: 1, hostBindings: function TuiFocusableDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("tabIndex", ctx.tabIndex);
    } }, inputs: { focusable: ["tuiFocusable", "focusable"] } });
__decorate([
    Input('tuiFocusable')
], TuiFocusableDirective.prototype, "focusable", void 0);
__decorate([
    HostBinding('tabIndex')
], TuiFocusableDirective.prototype, "tabIndex", null);

let TuiFocusableModule = class TuiFocusableModule {
};
TuiFocusableModule.ɵfac = function TuiFocusableModule_Factory(t) { return new (t || TuiFocusableModule)(); };
TuiFocusableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiFocusableModule });
TuiFocusableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiFocusableDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiFocusable]'
            }]
    }], function () { return []; }, { focusable: [{
            type: Input,
            args: ['tuiFocusable']
        }], tabIndex: [{
            type: HostBinding,
            args: ['tabIndex']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiFocusableModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiFocusableDirective],
                exports: [TuiFocusableDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiFocusableModule, { declarations: [TuiFocusableDirective], exports: [TuiFocusableDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFocusableDirective, TuiFocusableModule };

